<template>
  <div
    class="status-container d-flex"
    :class="{'show-status': open }"
  >
    <div
      v-if="hasApprovalStatus"
      class="comment-status-tag"
      data-testid="comment-status-tag"
      :class="hasApprovalStatus"
    >
      {{ approvalText }}
    </div>
    <div
      v-if="!resolved"
      class="comment-status-tag resolved"
    >
      Unresolved
    </div>
    <!-- Placeholder for animation -->
    <div class="comment-status-tag">
      &nbsp;
    </div>
  </div>
</template>

<script>
export default {
  name: 'PDPCommentStatusTag',
  props: {
    approved: {
      type: Boolean, // undefined === unapproved/pending moderation, false = denied
    },
    resolved: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      approvalStatus: this.approved,
      resolvedStatus: this.resolved,
      open: !this.resolved
        || !this.approved
        || typeof this.approved === 'undefined'
        || this.approved === null,
    };
  },
  computed: {
    hasApprovalStatus() {
      if (typeof this.approved === 'undefined' || this.approved === null) {
        return 'unapproved';
      }

      if (!this.approved) {
        return 'denied';
      }

      return '';
    },
    approvalText() {
      if (typeof this.approved === 'undefined' || this.approved === null) {
        return 'Pending Moderation';
      }

      if (!this.approved) {
        return 'Denied';
      }

      return '';
    },
  },
  watch: {
    resolved(newVal) {
      if (this.hasApprovalStatus) return;

      this.open = !newVal;
    },
    approved(newVal) {
      if (!this.resolved) return;

      this.open = !newVal || typeof newVal === 'undefined' || newVal === null;
    },
  },
};
</script>

<style lang="scss" scoped>
  .comment-status-tag {
    min-width: 98px;
    display: inline-block;
    border-radius: 3px 3px 0 0;
    font-style: normal;
    font-weight: 600;
    font-size: 10px;
    padding-top: 5px;
    padding-left: 10px;
    padding-right: 10px;
    padding-bottom: 5px;
    margin-right: 10px;
    text-align: center;
    color: #fff;
    text-shadow: 0 2px 2px rgba(0, 0, 0, 0.25);
    text-transform: capitalize;
  }

  .comment-status-tag.unapproved {
    background: #ff7a30;
  }

  .comment-status-tag.denied {
    background: #f00;
  }

  .comment-status-tag.resolved {
    background: #8458ff;
  }

  .status-container {
    transition: max-height 125ms ease-in-out;
    max-height: 0;
    min-height: 0;
    padding-top: 0;
    padding-bottom: 0;
    overflow: hidden;
    opacity: 0;
  }

  .show-status {
    max-height: 35px;
    opacity: 1;
  }
</style>
